import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { reject } from 'lodash';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Customer } from '../interfaces/customer';
import { Subscription } from '../interfaces/subscription';


@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  constructor(private http: HttpClient) { }

  getSubscribedCustomers(companyId: string): Observable<Customer[]> {
    console.log("COMPANY ID: ", companyId)
    return this.http
      .get<Subscription[]>(
        `${environment.url}/bucket/${environment.buckets.subscriptions}/data/?relation=true&filter={"company._id": "${companyId}"}`
      )
      .pipe(
        map(subscription => {
          return subscription.map(value => {
            return value.customer;
          });
        })
      );
  }
  hasSubscribed(customer_id: string, company_id: string) {
    return new Promise((resolve, reject) => {
      this.http
        .get<Subscription[]>(
          `${environment.url}/bucket/${environment.buckets.subscriptions}/data/?relation=true&filter={"company._id": "${company_id}","customer._id":"${customer_id}"}`
        ).subscribe(res => {
          if (res.length == 0) {
            resolve(false);
          }
          else {
            resolve(true);
          }
        }, err => reject(err));

    })
  }

  getCustomer(email: string): Promise<Customer> {
    console.log("getting customer: ", email)
    return new Promise((resolve, reject) => {
      this.http
        .get<Customer>(
          `${environment.url}/bucket/${environment.buckets.customers}/data?filter={"email": "${email}"}`
        ).subscribe(res => resolve(res), err => reject(err));

    })

  }
  addSubscription(sub: Subscription): Promise<Subscription> {
    return new Promise((resolve, reject) => {
      this.http
        .post<Subscription>(
          `${environment.url}/bucket/${environment.buckets.subscriptions}/data/`, sub
        ).subscribe(res => resolve(res), err => reject(err));

    })

  }

  addCustomer(email: string, name: string): Promise<Customer> {
    return new Promise((resolve, reject) => {
      let customer: Customer = {
        email: email,
        title: name
      }
      this.http
        .post<Customer>(
          `${environment.url}/bucket/${environment.buckets.customers}/data/`, customer
        ).subscribe(res => resolve(res), err => reject(err))
    })


  }
  isCustomerRegistered(email: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http
        .get<Customer[]>(
          `${environment.url}/bucket/${environment.buckets.customers}/data/?relation=true&filter={"email": "${email}"}`
        ).subscribe(res => {
          if (res.length == 0) {
            resolve(false)
          }
          else {
            resolve(true)
          }
        }, err => {
          reject(false)
        })

    })

  }
}
